<template>
  <footer class="relative overflow-hidden bg-slate-950 text-slate-200">
    <div class="absolute -top-20 -right-16 w-64 h-64 rounded-full bg-cyan-400/10 blur-3xl pointer-events-none"></div>
    <div class="absolute -bottom-20 -left-16 w-72 h-72 rounded-full bg-primary/15 blur-3xl pointer-events-none"></div>

    <div class="max-w-7xl mx-auto px-6 lg:px-8 py-12 md:py-14">
      <div class="rounded-3xl border border-white/10 bg-white/[0.03] backdrop-blur-xl p-7 md:p-10">
        <div class="grid lg:grid-cols-12 gap-10">
          
          <!-- BRAND INFO -->
          <div class="lg:col-span-6">
            <img src="/favicon.png" alt="AGSOFT" class="h-14 w-auto object-contain" />
            <p class="mt-3 text-slate-300/80 leading-relaxed max-w-md">
              Construimos software a la medida, sitios corporativos y soluciones de automatización para empresas que buscan avanzar con estructura.
            </p>
            <RouterLink
              to="/contacto"
              class="inline-flex items-center gap-2 mt-6 h-11 px-6 rounded-full bg-primary text-white font-bold hover:brightness-110 transition-all shadow-md shadow-primary/20">
              Solicitar asesoría
              <span class="material-symbols-outlined text-lg">arrow_forward</span>
            </RouterLink>
          </div>

          <!-- NAVEGACIÓN -->
          <div class="lg:col-span-3">
            <h4 class="text-xs uppercase tracking-[0.18em] text-slate-400 font-bold mb-4">Navegación</h4>
            <ul class="space-y-3">
              <li><RouterLink class="footer-link" to="/servicios">Servicios</RouterLink></li>
              <li><RouterLink class="footer-link" to="/por-que-nosotros">Por qué nosotros</RouterLink></li>
              <li><RouterLink class="footer-link" to="/contacto">Contacto</RouterLink></li>
            </ul>
          </div>

          <!-- LEGAL -->
          <div class="lg:col-span-3">
            <h4 class="text-xs uppercase tracking-[0.18em] text-slate-400 font-bold mb-4">Legal</h4>
            <ul class="space-y-3">
              <li><RouterLink class="footer-link" to="/politica-de-cookies">Política de Cookies</RouterLink></li>
              <li><RouterLink class="footer-link" to="/politica-de-privacidad">Política de Privacidad</RouterLink></li>
            </ul>
          </div>

        </div>

        <div class="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-2 md:items-center md:justify-between">
          <p class="text-sm text-slate-400">© {{ currentYear }} AGSOFT. Todos los derechos reservados.</p>
          <p class="text-sm text-slate-500">Hecho con enfoque en calidad y rendimiento.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { RouterLink } from 'vue-router';

const currentYear = new Date().getFullYear();
</script>

<style scoped>
.footer-link {
  color: rgb(203 213 225);
  transition: color 180ms ease, transform 180ms ease;
  display: inline-flex;
}

.footer-link:hover {
  color: #fff;
  transform: translateX(3px);
}
</style>